import { BarChart3, ClipboardCheck, FileText, Lightbulb, Target, TrendingUp } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

interface Benefit {
  icon: LucideIcon;
  title: string;
  description: string;
}

const benefits: Benefit[] = [
  {
    icon: Target,
    title: 'Identificação de gargalos',
    description:
      'Enxergue onde decisões, processos ou handoffs estão reduzindo a velocidade da operação.',
  },
  {
    icon: ClipboardCheck,
    title: 'Diagnóstico objetivo',
    description:
      'Avaliação estruturada e imparcial sobre como sua operação funciona hoje — sem achismos.',
  },
  {
    icon: BarChart3,
    title: 'Score por dimensões',
    description:
      'Visão clara da maturidade por área, com scores comparáveis entre dimensões críticas.',
  },
  {
    icon: FileText,
    title: 'Relatório acionável',
    description: 'Análise de gargalos, riscos e próximos passos priorizados.',
  },
  {
    icon: TrendingUp,
    title: 'Benchmark',
    description: 'Compare a performance da sua operação por dimensão analisada.',
  },
  {
    icon: Lightbulb,
    title: 'Clareza para decisão',
    description:
      'Transforme sinais dispersos em uma leitura clara para orientar prioridades e trade-offs.',
  },
];

export function ValueProposition() {
  return (
    <section
      className="py-24 px-4 sm:px-8 lg:px-16 border-t border-border"
      aria-labelledby="benefits-heading"
    >
      <div className="max-w-6xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16 space-y-4">
          <span className="text-primary text-sm font-medium uppercase tracking-widest">
            Beneficios
          </span>
          <h2 id="benefits-heading" className="text-3xl sm:text-4xl lg:text-5xl font-bold">
            Por que usar o Ops Review?
          </h2>
        </div>

        {/* Benefits grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {benefits.map((benefit, index) => (
            <div
              key={benefit.title}
              className="group p-6 rounded-2xl border border-border bg-card hover:border-primary/30 transition-colors"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="mb-4 p-3 w-fit rounded-xl bg-primary/10">
                <benefit.icon className="h-6 w-6 text-primary" aria-hidden="true" />
              </div>
              <h3 className="text-lg font-semibold mb-2">{benefit.title}</h3>
              <p className="text-sm text-muted-foreground leading-relaxed">{benefit.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
